import { render } from "./404.vue?vue&type=template&id=7138bc36&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=7138bc36&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/91znxra3/0/im/im-manager-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7138bc36"]])

export default __exports__